import { computed, ref, toValue, type MaybeRefOrGetter } from 'vue';
import { mergeColorPalette, normalizeHexColor, normalizeRecentColors, rememberRecentColor, type ColorSwatch } from '@yana/shared';

export const RECENT_COLORS_STORAGE_KEY = 'yana.colors.recent';

// Общая история на приложение: выбор в одном меню сразу виден в остальных.
const recentColors = ref<string[]>([]);
let initialized = false;

function parseHistory(raw: string | null): string[] {
  try {
    return normalizeRecentColors(JSON.parse(raw ?? 'null'));
  } catch {
    return [];
  }
}

function initialize(): void {
  if (initialized || typeof window === 'undefined') return;
  initialized = true;
  try {
    recentColors.value = parseHistory(window.localStorage.getItem(RECENT_COLORS_STORAGE_KEY));
  } catch {
    // Закрытое хранилище не мешает пользоваться палитрой в текущей вкладке.
  }
  window.addEventListener('storage', (event) => {
    if (event.key === RECENT_COLORS_STORAGE_KEY || event.key === null) {
      recentColors.value = parseHistory(event.newValue);
    }
  });
}

export function useColorPalette(
  defaults: MaybeRefOrGetter<readonly ColorSwatch[]>,
  current?: MaybeRefOrGetter<string | null | undefined>,
) {
  initialize();
  const colors = computed(() => mergeColorPalette(toValue(defaults), recentColors.value, toValue(current)));

  function rememberColor(value: string | null): void {
    const hex = normalizeHexColor(value);
    if (!hex) return;
    recentColors.value = rememberRecentColor(recentColors.value, hex);
    try {
      window.localStorage.setItem(RECENT_COLORS_STORAGE_KEY, JSON.stringify(recentColors.value));
    } catch {
      // В памяти выбранный цвет остаётся и без localStorage.
    }
  }

  return { colors, rememberColor };
}
